import { jsxs as E, jsx as e } from "react/jsx-runtime";
import { useState as l, useRef as w, useEffect as A } from "react";
import { Container as P, ArrowPrev as R, ArrowIcon as C, Carousel as S, ListImages as j, ArrowNext as k, ProgressBar as M } from "./style.js";
import { ChevronLeft as T, ChevronRight as b } from "@pelando/fontawesome/icons";
function q({
  listImages: g,
  numberOfImages: o = 4,
  handleNextButton: u
}) {
  const [n, r] = l(0), h = w(null), [f, d] = l(null), [v, I] = l(null), s = o - 1, i = o === 1, m = () => {
    n >= s ? r(0) : r(n + 1), u && u();
  }, p = () => {
    r(n === 0 ? s : n - 1);
  }, c = (t) => {
    d(t.touches[0].clientX), I(t.touches[0].clientY);
  }, a = (t) => {
    if (f === null || v === null)
      return;
    const X = t.touches[0].clientX, L = t.touches[0].clientY, x = f - X, Y = v - L;
    Math.abs(x) > Math.abs(Y) && (x > 0 ? m() : p()), d(null), I(null), t.preventDefault();
  };
  return A(() => {
    const t = h.current;
    return t == null || t.addEventListener("touchstart", c), t == null || t.addEventListener("touchmove", a), () => {
      t == null || t.removeEventListener("touchstart", c), t == null || t.removeEventListener("touchmove", a);
    };
  }, [a, c]), /* @__PURE__ */ E(P, { children: [
    !i && /* @__PURE__ */ e(
      R,
      {
        onClick: () => p(),
        "aria-hidden": n === 0,
        children: /* @__PURE__ */ e(C, { icon: T })
      }
    ),
    /* @__PURE__ */ e(S, { children: /* @__PURE__ */ e(
      j,
      {
        style: { transform: `translateX(-${n * 100}%)` },
        ref: h,
        children: g
      }
    ) }),
    !i && /* @__PURE__ */ e(
      k,
      {
        onClick: () => m(),
        "aria-hidden": n === s,
        children: /* @__PURE__ */ e(C, { icon: b })
      }
    ),
    !i && /* @__PURE__ */ e(
      M,
      {
        numberOfSteps: o,
        currentStepIndex: n
      }
    )
  ] });
}
export {
  q as ImageCarousel
};
